document.addEventListener("DOMContentLoaded", function () {
    // 公共弹窗
    class YGPopupBox extends HTMLElement {
        constructor() {
            super();
            this.clickClosePopup = this.clickClosePopup.bind(this);
            this.clickOpenPopup = this.clickOpenPopup.bind(this);
            this.$contentInner = null;
        }

        connectedCallback() {
            this.$contentInner = this.querySelector('.yg-popup-box-content-inner');
            this.addEventListener('click', this.clickClosePopup)
            document.addEventListener("YGPopup:open", this.clickOpenPopup)
        }

        disconnectedCallback() {
            this.removeEventListener('click', this.handleClick);
            document.removeEventListener('YGPopupBox:open', this.handleOpenEvent);
        }

        clickOpenPopup(event) {
            const { $popupTemplate, fn } = event.detail;
            this.openPopup($popupTemplate, fn);
        }

        clickClosePopup(e) {
            this.closePopup(e, () => { });
        }

        openPopup($popupTemplate, fn) {
            // popupTemplate：需要替换的元素
            if (!$popupTemplate || !this.$contentInner) return;
            this.$contentInner.innerHTML = $popupTemplate.innerHTML;
            document.body.style.overflow = 'hidden';
            this.style.display = 'flex';
            typeof fn === 'function' && fn();
        }

        closePopup(e, fn) {
            let closeClassName = ["yg-popup-box-close", "yg-popup-box"]
            if (closeClassName.some(className => e.target.classList.contains(className))) {
                this.style.display = 'none';
                this.$contentInner.innerHTML = '';
                document.body.style.overflow = 'auto';
                typeof fn === 'function' && fn();
            }
        }
    }
    if (!window.customElements.get('yg-popup-box')) {
        window.customElements.define('yg-popup-box', YGPopupBox);
    }
    // 公共打开弹窗逻辑
    class YGOpenPopup extends HTMLElement {
        constructor() {
            super();
            // 执行函数并指向自身
            this.itemClick = this.itemClick.bind(this);
        }
        // 当元素插入 DOM 时，添加点击事件监听器
        connectedCallback() {
            this.addEventListener('click', this.itemClick);
        }
        // 当元素从 DOM 移除时，清理事件监听器，防止内存泄漏
        disconnectedCallback() {
            this.removeEventListener('click', this.itemClick);
        }
        // 当元素被点击时，尝试查找 <template> 或类名为 yg-popup-template 的子元素作为弹窗模板
        itemClick() {
            let $popupTemplate = this.querySelector('template') || this.querySelector('.yg-popup-template');
            if ($popupTemplate) {
                document.dispatchEvent(new CustomEvent("YGPopup:open", {
                    bubbles: true,
                    detail: {
                        $popupTemplate,
                        fn: () => { }
                    }
                }))
            }
        }
    }
    if (!window.customElements.get('yg-open-popup')) {
        window.customElements.define('yg-open-popup', YGOpenPopup);
    }
    class YGSwiper extends HTMLElement {
        constructor() {
            super()
            this.init()
        }
        init() {
            this.showSwiper()
        }
        showSwiper() {
            new Swiper(this, {
                slidesPerView: 5,
                spaceBetween: 20,
                pagination: {
                    el: '.swiper-pagination',
                    type: 'progressbar',   // 设置为进度条
                }
            });
        }
    }

    if (!window.customElements.get('yg-swiper')) {
        window.customElements.define('yg-swiper', YGSwiper);
    }

    const $box = document.querySelectorAll('.yg-mega-menu-wrapper');

    $box.forEach((el) => {
      const $tabs = el.querySelectorAll('.tab');
      const $allObjectGroups = el.querySelectorAll('.object-group');
      const $objectList = el.querySelectorAll('.yg-object-list-wrapper');

      if ($tabs) {
        $tabs.forEach((tab, index) => {
          const tabIndex = tab.getAttribute('data-tab-index');
          const sub_links = tab.querySelectorAll('.yg-sub_link-item');

          tab.querySelector('summary').addEventListener('click', (event) => {
            const openTabs = Array.from($tabs).filter((t) => t.hasAttribute('open'));
            sub_links[0].classList.add('is-active');
            $objectList.forEach((object) => {
              object.classList.remove('active');
            })
            $objectList[index].classList.add('active');
            $objectList[index].querySelector('.object-group:first-child').style.display = 'block';
            if (openTabs.length > 0) {
              $tabs.forEach((t) => {
                if (t !== tab) t.removeAttribute('open');
              });
            }
          });

          sub_links.forEach((sub_link) => {
            sub_link.addEventListener('click', () => {
              const subIndex = sub_link.getAttribute('data-sub_link-index');
              showSub_linkProducts(tabIndex, subIndex);
            });
          });
        });
      }

      function showSub_linkProducts(tabIndex, subIndex) {
        if ($allObjectGroups.length > 0) {
          $allObjectGroups.forEach((g) => (g.style.display = 'none'));
        }

        const activeGroup = el.querySelector(
          `.object-group[data-tab-index="${tabIndex}"][data-sub_link-index="${subIndex}"]`
        );
        if (activeGroup) {
          activeGroup.style.display = 'flex';
        }

        el.querySelectorAll('.yg-sub_link-item').forEach((el) => el.classList.remove('is-active'));
        const activeSub_link = el.querySelector(
          `.yg-sub_link-item[data-tab-index="${tabIndex}"][data-sub_link-index="${subIndex}"]`
        );
        if (activeSub_link) {
          activeSub_link.classList.add('is-active');
        }
      }
    });

})


